// extracted by mini-css-extract-plugin
module.exports = {"bottom-nav-wrapper":"YdMN3","tabs":"_1VvLi","tab":"_24tQv","tab__icon":"_3kqj2","red":"_3UM7g"};